export const CloseClicked = 'travelPeriodField/closeClicked';
export const DurationChanged = 'travelPeriodField/durationChanged';
export const RangeChanged = 'travelPeriodField/rangeChanged';
export const ValueChanged = 'travelPeriodField/valueChanged';
export const FunctionValueChanged = 'travelPeriodField/functionValueChanged';